const TierZeroMark = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 15 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M9.084 0H0V12.78H2.1656V5.4624C2.1656 4.2688 1.8168 3.0992 1.1592 2.0864H9.084V0Z" fill="currentColor"/>
    <path d="M12.3392 8.1784V15.496C12.3392 16.6896 12.688 17.8592 13.3456 18.872H5.4208V20.9584H14.5048V8.1784H12.3392Z" fill="currentColor"/>
    <path d="M12.0336 0L0 20.9584H2.4712L14.5048 0H12.0336Z" fill="currentColor"/>
  </svg>
);

export default TierZeroMark;
